import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { listTournaments } from "../redux/actions/tournamentActions";

import "../styles/pages/HomePage.scss";

import TournamentCard from "../components/Cards/TournamentCard";

import { tournaments_data } from "../__FakeDatabase/Tournaments_data";
import NavigationComponents from "../components/NavigationComponents/Main Pages/NavigationComponents";
import { basketball_tournaments_data } from "../__fakeBasketballDatabase/Tournaments_data";
import PromoteMySelf from "../components/PromoteMySelf";

function HomePage() {
  const dispatch = useDispatch();
  const { error, loading, tournaments } = useSelector(
    (state) => state.tournamentList,
  );

  const [tournamentsList, setTournamentsList] = useState([]);

  useEffect(() => {
    dispatch(listTournaments());
  }, [dispatch]);

  useEffect(() => {
    document.title = `Martin's Tournaments`;
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!tournaments) return;

    setTournamentsList(tournaments);
  }, [tournaments]);

  return (
    <NavigationComponents>
      <div className="homePage">
        <div className="tournamentCardsSection">
          <div className="tournamentsContainerWrapper">
            <div className="tournamentsContainer">
              {basketball_tournaments_data?.map((tournament, index) => {
                if (tournament.isNew) {
                  return (
                    <TournamentCard
                      tournament={tournament}
                      key={index}
                      isBasketball={true}
                    />
                  );
                }
              })}
              {tournaments_data?.map((tournament, index) => (
                <TournamentCard tournament={tournament} key={index} />
              ))}
              {tournamentsList?.map((tournament, index) => (
                <TournamentCard tournament={tournament} key={index} />
              ))}
              {basketball_tournaments_data?.map((tournament, index) => {
                if (!tournament.isNew) {
                  return (
                    <TournamentCard
                      tournament={tournament}
                      key={index}
                      isBasketball={true}
                    />
                  );
                }
              })}
            </div>
          </div>
        </div>

        <PromoteMySelf />
      </div>
    </NavigationComponents>
  );
}

export default HomePage;
